import { Action, AnyAction, createActionCreator } from 'deox';
import { ApplicationResult } from 'fmc-sdk';
import { PrescreenApplicationResult } from 'fmc-sdk/src/actions';

export const ReceiveApplicationResult = 'FMC:RECEIVE_APPLICATION_RESULT';

export const fmcApplicationResult = createActionCreator(
  ReceiveApplicationResult, resolve =>
    (payload: (ApplicationResult | PrescreenApplicationResult)) => resolve(payload)
);

export function createFmcAction(action: AnyAction){
  return {payload:{}, ...action, type: `FMC:${action.type}`}
}
